/** 會員身份：顯示名稱與標籤色 */
export const MEMBER_IDENTITY_LABELS = {
    guest: '遊客',
    student: '學員',
    partner: '夥伴',
    manager: '管理員',
    admin: '管理員'
};

/**
 * Ant Design Tag color（各身份明顯區分）
 * 遊客＝灰、學員＝綠、夥伴＝藍、管理員＝墨藍
 */
export const MEMBER_IDENTITY_TAG_COLORS = {
    guest: 'default',
    student: 'green',
    partner: 'blue',
    manager: 'geekblue',
    admin: 'geekblue'
};

export const getIdentityName = (identity) =>
    MEMBER_IDENTITY_LABELS[identity] || identity || '-';

export const getIdentityTagColor = (identity) =>
    MEMBER_IDENTITY_TAG_COLORS[identity] || 'default';
